export {};

// Extend String interface
declare global {
    interface String {
        clean(): string;
    }
}

// Implement the extension
String.prototype.clean = function (): string {
    // Match directional characters and zero-width characters
    return this.trim().replace(/[\u202A-\u202E\u200B-\u200F\uFEFF]/g, '');
};
